export const goToHelp = async () => {
  window.open('https://community.1edtech.org/support-request/support-request')
}
